import { createReducer } from '@reduxjs/toolkit';
import {
  addMotiveExceptionErrorAction,
  addMotiveExceptionSuccessAction,
  clearMotiveExceptionErrorsAction,
  deleteMotiveExceptionErrorAction,
  deleteMotiveExceptionSuccessAction,
  setMotiveExceptionsAction,
  setMotiveExceptionsErrorAction,
  setMotiveExceptionsLoadingAction,
  updateMotiveExceptionErrorAction,
  updateMotiveExceptionSuccessAction,
} from 'store/actions/motive-exception-actions';
import IMotiveExceptionsState from 'types/company/payroll/IMotiveExceptionsState';

const initialState: IMotiveExceptionsState = {
  motiveExceptions: [],
  loading: false,
  getError: false,
  addError: '',
  addSuccess: false,
  updateError: '',
  updateSuccess: false,
  deleteError: '',
  deleteSuccess: false,
};

const motiveExceptionReducer = createReducer(initialState, builder => {
  return builder
    .addCase(setMotiveExceptionsAction, (state, action) => ({ ...state, motiveExceptions: action.payload }))
    .addCase(setMotiveExceptionsLoadingAction, (state, action) => ({ ...state, loading: action.payload }))
    .addCase(setMotiveExceptionsErrorAction, (state, action) => ({ ...state, getError: action.payload }))
    .addCase(addMotiveExceptionSuccessAction, (state, action) => ({ ...state, addSuccess: action.payload }))
    .addCase(addMotiveExceptionErrorAction, (state, action) => ({ ...state, addError: action.payload }))
    .addCase(updateMotiveExceptionSuccessAction, (state, action) => ({ ...state, updateSuccess: action.payload }))
    .addCase(updateMotiveExceptionErrorAction, (state, action) => ({ ...state, updateError: action.payload }))
    .addCase(deleteMotiveExceptionSuccessAction, (state, action) => ({ ...state, deleteSuccess: action.payload }))
    .addCase(deleteMotiveExceptionErrorAction, (state, action) => ({ ...state, deleteError: action.payload }))
    .addCase(clearMotiveExceptionErrorsAction, state => ({
      ...state,
      addError: '',
      addSuccess: false,
      updateError: '',
      updateSuccess: false,
      deleteError: '',
      deleteSuccess: false,
    }));
});

export default motiveExceptionReducer;
